import React from "react";

function Table({ data, func }: any) {
  return (
    <table className="w-full text-sm text-left text-gray-500 table-fixed dark:text-gray-400">
      <thead className="text-gray-700 uppercase bg-gray-50 text-md md:text-lg dark:bg-gray-700 dark:text-gray-400">
        <tr>
          <th className="text-center">What ?</th>
          <th className="text-center">For whom ?</th>
          <th className="text-center">How</th>
        </tr>
      </thead>
      <tbody className="border-gray-300 md:text-lg border-y">
        {data.map((item: any, index: any) => (
          <tr
            key={index}
            className="my-5 border-b border-gray-300 border-3 border-x even:bg-gray-200 hover:bg-gray-300 hover:cursor-pointer"
            onClick={() => func(item.what)}
          >
            <td className="text-center">{item.what}</td>
            <td className="text-center">{item.forWhom}</td>
            <td className="text-left">{item.how}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default Table;
